"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const startCase_1 = __importDefault(require("lodash/startCase"));
const Badge_1 = __importDefault(require("components/shared/Badge"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const AdvanceFilter_1 = require("src/components/filter/AdvanceFilter");
const useFilter_1 = __importDefault(require("src/hooks/global-state/useFilter"));
const SelectedFilter = ({ selectedOptions }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, selectedOptions.map((option) => {
        return react_1.default.createElement(SelectedBadge, { key: option.key, option: option });
    })));
};
const SelectedBadge = ({ option }) => {
    const { id } = (0, AdvanceFilter_1.useAdvanceFilter)();
    const filter = (0, useFilter_1.default)((state) => state.filter, (oldState, newState) => {
        // prevent rerender if the changes is not related to current key
        return (0, isEqual_1.default)(oldState[id]?.[option.key], newState[id]?.[option.key]);
    });
    const getContent = (values) => {
        if (Array.isArray(values)) {
            return values.reduce((prev, value) => {
                value = (0, startCase_1.default)(value);
                return prev == '' ? value : prev + ', ' + value;
            }, '');
        }
        return values;
    };
    const content = getContent(filter[id]?.[option.key]);
    if (!content)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "flex items-center", key: option.key },
        react_1.default.createElement(Badge_1.default, { className: "mr-[4px]", title: (0, startCase_1.default)(option.key), content: content }),
        !option.immutable && react_1.default.createElement(ClearIcon, { option: option })));
};
const ClearIcon = ({ option }) => {
    const { id } = (0, AdvanceFilter_1.useAdvanceFilter)();
    const filter = (0, useFilter_1.default)((state) => state.filter);
    const setFilter = (0, useFilter_1.default)((state) => state.setFilter);
    const handleClearFilter = (key) => {
        const newFilter = (0, cloneDeep_1.default)(filter[id]);
        newFilter[key] = [];
        setFilter(id, newFilter);
    };
    return (react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-clear", size: 16, fillColor: "var(--n-600)", customClass: "mr-[16px]", onClick: () => handleClearFilter(option.key) }));
};
exports.default = SelectedFilter;
